import { useEffect } from "react";
import SectionAPI from "../../api/SectionAPI";
import ZoneAPI from "../../api/ZoneAPI";
import Layout from "../../components/Layout";
import SectionRow from '../../components/SectionRow'


const SectionDetailView = (props) => { 
    useEffect(() => console.log(props), [])
    
    return <Layout overrideStyle={{backgroundColor: 'white'}} title={"ETA - " + props.section.title + " in " + props.zone.name} description={props.section.description}>
        <div style={{marginTop: 60}}>
        <h1>{props.section.title}</h1>
        <p style={{fontSize: '1.5em'}}>{props.section.description}</p>
        <SectionRow item={props.section} rowItemCount={4}/>
    </div>
    </Layout>
}

SectionDetailView.getInitialProps = async (ctx: any) => { 
    const sectionsApi = new SectionAPI();
    const zoneApi = new ZoneAPI();
    const result = await sectionsApi.getSection(ctx.query.id, {zoneSlug: ctx.query.zone});
    const zone = await zoneApi.getZone(ctx.query.zone);
    var props: any = {};
    console.log(result)
    if (result && result.code !== -1 ) { 
        props.section = result;
    } else { 
        ctx.res.redirect('/404')
    } 
    if (zone && zone.code !== -1) { 
        props.zone = zone;
    }

    return props;
}

export default SectionDetailView;